import { Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ENVIRONMENT_WEBSITE_TOKEN, EnvironmentWebsiteInterface } from '@campus/environment';
import { StringFunctions } from '@campus/utils';

import { DcrBreadcrumbInterface } from '@diekeure/dcr-components';
import '@diekeure/dcr-components/dcr-breadcrumb-group.js';
import '@diekeure/dcr-components/dcr-breadcrumb.js';

export interface BreadcrumbLinkInterface {
  displayText: string;
  link: string[];
  queryParams?: Record<string, string | number | boolean>;
}

@Component({
  standalone: false,
  selector: 'campus-breadcrumbs-v2',
  templateUrl: './breadcrumbs-v2.component.html',
})
export class BreadcrumbsV2Component implements OnChanges {
  @Input() separator: string;
  @Input() breadcrumbs: BreadcrumbLinkInterface[] = [];

  public dcrBreadcrumbs: DcrBreadcrumbInterface[] = [];

  private router: Router = inject(Router);
  private environment: EnvironmentWebsiteInterface = inject(ENVIRONMENT_WEBSITE_TOKEN);

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.breadcrumbs && this.breadcrumbs?.length) {
      const filteredBreadcrumbs = this.breadcrumbs.filter((breadcrumb) => breadcrumb.displayText && breadcrumb.link);

      // Remove trailing slash from the URL to avoid double slashes in the link
      const baseUrl = this.environment.url.replace(/\/$/, '');

      this.dcrBreadcrumbs = [];

      // Add platform URL to the breadcrumb links
      const platformBreadcrumb: DcrBreadcrumbInterface = {
        label: StringFunctions.capitalizeFirstLetter(this.environment.title),
        href: `${baseUrl}/v2`,
        current: false,
      };

      const pageBreadcrumbs: DcrBreadcrumbInterface[] = filteredBreadcrumbs.map(
        (breadcrumb: BreadcrumbLinkInterface, index: number): DcrBreadcrumbInterface => {
          const isLast = index === filteredBreadcrumbs.length - 1;
          const urlTree = this.router.createUrlTree(breadcrumb.link, {
            queryParams: breadcrumb.queryParams,
          });

          return {
            label: breadcrumb.displayText,
            href: `${baseUrl}${urlTree.toString()}`,
            current: isLast,
          };
        }
      );

      this.dcrBreadcrumbs = [platformBreadcrumb, ...pageBreadcrumbs];
    }
  }

  public breadcrumbClick(event: MouseEvent, breadcrumb: DcrBreadcrumbInterface): void {
    // Prevent current breadcrumbs to navigate
    // they are only for indication
    if (breadcrumb.current) {
      return;
    }
    // Prevent the default routing with a href link. Because it will full reload the page.
    // Use the router.navigate instead.
    event.preventDefault();

    const urlParts = breadcrumb.href.replace(this.environment.url, '').split('/');

    this.router.navigate(urlParts);
  }
}
